import { call, put } from 'redux-saga/effects';
import { AxiosError, AxiosResponse } from 'axios';

// Response / Request
import { Result } from '@models/common/resultResponse';
import { KeyValue } from '@/main/models/common';

// Redux
import { saveBodyshopBranches, GetBodyshopBranches } from './index';

// Api's
import { bodyshopApi } from '../../api';
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from '@/main/services/utils';

export function* getBodyshopBranchesSaga(action: GetBodyshopBranches) {
  try {
    const response: AxiosResponse<Result<KeyValue[]>> = yield call(
      bodyshopApi.getBodyshopsOrBodyshopBranchesDomain,
      action.payload.request
    );
    if (response.data.result) {
      yield put(saveBodyshopBranches(response.data.result, false, null));
    }
  } catch (exception) {
    if (exception instanceof AxiosError) {
      const resultError = errorBoundaryReduxSaga(exception);
      renderErrorReduxSaga(resultError);

      yield put(saveBodyshopBranches(null, true, resultError.messagesDataError));
    }
  }
}
